<div class="popup-container">
    <button mat-button mat-dialog-close (click)="closeDialog()" class="close black-button">X</button>

    <h2 class="p-3 mb-0 roboto-medium">{{message}}</h2>
    <hr id="shadow"><br>
    <div>
        <p>{{data}}</p>
    </div>
</div>
